import { inject, Injectable } from '@angular/core';
import { UserPreferencesStore } from '@app/shared/stores/user-preferences.store';
import { PriceSettingEnum } from '@infrastructure/price-setting.enum';
import { PriceSettingModel } from '@models/price-setting.model';
import { UserDataModel } from '@models/user-data-model';
import { UserTypeConstant } from '@shared/user-type-constants';
import { LanguageService } from './language.service';

@Injectable({
	providedIn: 'root'
})
export class PriceSettingsService {

	userPreferencesStore = inject(UserPreferencesStore);

	private allPriceSettings: PriceSettingModel[];

	constructor(
		private languageService: LanguageService,
	) {
		this.allPriceSettings = [];

		this.allPriceSettings.push(new PriceSettingModel(PriceSettingEnum.AllowAll, this.languageService.instant("OPTIONS-DROPDOWN.PRICESETTINGS.SHOW.BOTH")));
		this.allPriceSettings.push(new PriceSettingModel(PriceSettingEnum.AllowNetPrice, this.languageService.instant("OPTIONS-DROPDOWN.PRICESETTINGS.SHOW.NET.PRICE")));
		this.allPriceSettings.push(new PriceSettingModel(PriceSettingEnum.AllowSuggestedRetailPrice, this.languageService.instant("OPTIONS-DROPDOWN.PRICESETTINGS.SHOW.SUGGESTED.RETAIL.PRICE")));
		this.allPriceSettings.push(new PriceSettingModel(PriceSettingEnum.AllowNone, this.languageService.instant("OPTIONS-DROPDOWN.PRICESETTINGS.SHOW.NONE")));
	}

	public getPriceText(index?: number) {
		let priceText: string = '';

		if (!index) {
			priceText = this.languageService.instant("OPTIONS-DROPDOWN.PRICESETTINGS.SHOW.NONE");

			return priceText;
		}

		switch (index) {
			case PriceSettingEnum.AllowNone:
				priceText = this.languageService.instant("OPTIONS-DROPDOWN.PRICESETTINGS.SHOW.NONE")
				break;
			case PriceSettingEnum.AllowNetPrice:
				priceText = this.languageService.instant("OPTIONS-DROPDOWN.PRICESETTINGS.SHOW.NET.PRICE")
				break;
			case PriceSettingEnum.AllowSuggestedRetailPrice:
				priceText = this.languageService.instant("OPTIONS-DROPDOWN.PRICESETTINGS.SHOW.SUGGESTED.RETAIL.PRICE")
				break;
			case PriceSettingEnum.AllowAll:
				priceText = this.languageService.instant("BAG.PRICE.NET") + ' (' + this.languageService.instant("BAG.PRICE.RETAIL") + ')';
				break;
		}

		return priceText;
	}

	public getAllowedPriceSettings(user: UserDataModel | null) {
		let allowedPriceSettings: (PriceSettingModel | undefined)[] = [];

		if (user?.PriceSettingAllowed && user.PriceSettingAllowed > 0) { //!== PriceSetting.AllowNone) {
			switch (user.PriceSettingAllowed) {
				case PriceSettingEnum.AllowNetPrice:
					allowedPriceSettings.push(this.allPriceSettings.find(ps => ps.PriceSetting === PriceSettingEnum.AllowNetPrice));
					allowedPriceSettings.push(this.allPriceSettings.find(ps => ps.PriceSetting === PriceSettingEnum.AllowNone));
					break;

				case PriceSettingEnum.AllowSuggestedRetailPrice:
					allowedPriceSettings.push(this.allPriceSettings.find(ps => ps.PriceSetting === PriceSettingEnum.AllowSuggestedRetailPrice));
					allowedPriceSettings.push(this.allPriceSettings.find(ps => ps.PriceSetting === PriceSettingEnum.AllowNone));
					break;

				case PriceSettingEnum.AllowAll:
					allowedPriceSettings.push(this.allPriceSettings.find(ps => ps.PriceSetting === PriceSettingEnum.AllowNetPrice));
					allowedPriceSettings.push(this.allPriceSettings.find(ps => ps.PriceSetting === PriceSettingEnum.AllowSuggestedRetailPrice));
					allowedPriceSettings.push(this.allPriceSettings.find(ps => ps.PriceSetting === PriceSettingEnum.AllowNone));

					if (user.Type === UserTypeConstant.Employee) {
						allowedPriceSettings.push(this.allPriceSettings.find(ps => ps.PriceSetting === PriceSettingEnum.AllowAll));
					}

					break;

				default:
					// ERROR
					break;
			}

			allowedPriceSettings.sort((a, b) => (a?.PriceSetting ?? 0) - (b?.PriceSetting ?? 0));
		}
		else {
			allowedPriceSettings.push(this.allPriceSettings.find(ps => ps.PriceSetting === PriceSettingEnum.AllowNone));
		}

		return allowedPriceSettings;
	}

}
